import React, {useEffect, useState} from 'react';
import {Accordion, Row, Col, Form} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import IconButton from './IconButton';
import CustomDatePicker from './CustomDatePicker';
import {getDocumentStatus} from '../../lib/api/document';
import {listUserClub} from '../../lib/api/club';

const SearchAccordion = ({document_type_id, paramsObj, handleSearch, handleExport, exporting = false}) => {

    const [status, setStatus] = useState([]);
    const [clubs, setClubs] = useState([]);
    const [params, setParams] = useState(paramsObj || {});
    const [search, setSearch] = useState(paramsObj || {});

    const handleInputChange = e => {
        const { name, value } = e.target;
        setSearch(prev => {
            const updated = { ...prev };
            if (value === '') {
                delete updated[name]; // obriši polje ako je prazno
            } else {
                updated[name] = value;
            }
            return updated;
        });
    };

    const handleDateChange = (name, value) => {
        setSearch(prev => {
            const updated = { ...prev };
            if (!value) {
                delete updated[name]; // obriši polje ako je null/undefined
            } else {
                updated[name] = value.toISOString().split('T')[0];
            }
            return updated;
        });
    };

    const handleReset = () => {
        setSearch({});
        setParams({});
        handleSearch({})
    };

    useEffect(() => {
        (async () => {

            console.log('Search state changed:', search);

            try {
                const rowStatus = await getDocumentStatus({"document_type_id": document_type_id});
                setStatus(rowStatus);

                const rowClubs = await listUserClub()
                setClubs(rowClubs);

                if (params && Object.keys(params).length > 0) {
                    handleSearch(params); // poziva pretragu odmah
                }

            } catch (error) {
            }
        })();
    }, []);

    return (
        <Accordion defaultActiveKey={Object.keys(params).length > 0 ? "0" : null}>
            <Accordion.Item eventKey="0">
                <Accordion.Header><FontAwesomeIcon icon="search" className="fs-10 me-2" /><strong>Pretraga</strong></Accordion.Header>
                <Accordion.Body>
                    <Form.Group as={Col} md="12" method="POST" encType="multipart/form-data" noValidate>
                        <Row className="flex-between-center mb-3">
                            <Col md={2}>
                                <Form.Label>ID</Form.Label>
                                <Form.Control
                                    required
                                    type="text"
                                    name="t_id"
                                    value={search.t_id || ''}
                                    onChange={handleInputChange}
                                />
                            </Col>
                            <Col md={4}>
                                <Form.Label>Klub</Form.Label>
                                <Form.Select name="t_club_entities_id"  onChange={handleInputChange}>
                                    {clubs.length > 1 && <option value="">Izaberi</option>}
                                    {clubs.map(p => (
                                        <option key={p.entities_id} value={p.entities_id}>
                                            {p.name}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Col>
                            <Col md={3}>
                                <Form.Label>Datum</Form.Label>
                                <CustomDatePicker
                                    name="t_date"
                                    selectedDate={search.t_date || null}
                                    onChange={handleDateChange}
                                />
                            </Col>
                            <Col md={3}>
                                <Form.Label>Status</Form.Label>
                                <Form.Select name="t_status_id"  onChange={handleInputChange}>
                                    {status.length > 1 && <option value="">Izaberi</option>}
                                    {status.map(p => (
                                        <option key={p.documents_status_id} value={p.documents_status_id}>
                                            {p.name}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Col>
                        </Row>
                        <Row className="flex-between-center mb-3">
                            <Col md="12" className="text-end mt-2">
                                {handleExport && (
                                    <IconButton
                                        className="rounded-pill me-2 mb-1"
                                        variant="falcon-primary"
                                        icon="external-link-alt"
                                        transform="shrink-3"
                                        disabled={exporting}
                                        onClick={() => handleExport(search)}
                                    >
                                        {exporting ? 'Izvoz u toku...' : 'Export'}
                                    </IconButton>
                                )}
                                <IconButton
                                    className="rounded-pill me-1 mb-1"
                                    variant="falcon-primary"
                                    icon="search"
                                    transform="shrink-3"
                                    onClick={() =>
                                        (params && Object.keys(params).length > 0)
                                            ? handleReset()
                                            : handleSearch(search)
                                    }
                                >
                                    {params && Object.keys(params).length > 0 ? 'Poništi' : 'Pretraga'}
                                </IconButton>
                            </Col>
                        </Row>
                    </Form.Group>
                </Accordion.Body>
            </Accordion.Item>
        </Accordion>
    );
};

export default SearchAccordion;
